import React from "react";
import { Layout } from "./components/Layout";
import Router from "./components/Router";

export default function App() {
  return (
    <Layout>
      <Router></Router>
    </Layout>
  );
}
